import type { CampaignType } from "@adpilot/shared";
import { Badge } from "@/components/ui/badge";

const TYPE_VARIANTS = {
  sp: "sp",
  sb: "sb",
  sd: "sd",
} as const satisfies Record<CampaignType, "sp" | "sb" | "sd">;

interface CampaignTypeBadgeProps {
  campaignType: CampaignType;
}

export function CampaignTypeBadge({ campaignType }: CampaignTypeBadgeProps) {
  return <Badge variant={TYPE_VARIANTS[campaignType]}>{campaignType.toUpperCase()}</Badge>;
}
